// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_rx-0";